import CourseCard, { CourseCardProps } from './CourseCard';

export type { CourseCardProps };
export default CourseCard;
